var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibertyDownloadArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M13.4321 6.25919L8.61965 10.8987V0H6.38027V10.8987L1.56778 6.25919L0 7.76961L7.5 15L15 7.76961L13.4321 6.25919Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    d: "M1 17H14V19H1V17Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibertyDownloadArrow);
export default __webpack_public_path__ + "static/media/liberty-download-arrow.b22d82c51f6fcbdb58921050182500c7.svg";
export { ForwardRef as ReactComponent };